import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IntervalService } from '@services/interval/interval.service';

@Component({
    selector: 'app-autologout-dialog',
    templateUrl: './autologout-dialog.component.html',
    styleUrls: ['./autologout-dialog.component.scss'],
    standalone: false
})

export class AutologoutDialogComponent implements OnInit {
  countdown = 30;

  constructor(
    public dialogRef: MatDialogRef<AutologoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.changeFavicon('assets/warning-icon.png');
    IntervalService.set('autologout', () => {
      if (this.countdown === 0) {
        IntervalService.clear('autologout');
      }
      this.countdown = this.countdown - 1;
      document.title = 'Logout in: ' + this.countdown.toString();
    }, 1000)
  }

  changeFavicon(url) {
    let link: any = document.querySelector('link[rel~="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  }
}
